export const FILTER_TYPES = {
  search: 'search',
  userType: 'userType',
  isActive: 'isActive',
  isApproved: 'isApproved',
  date: 'date',
  subscriptionTier: 'subscriptionTier',
  contentType: 'contentType',
  reportTicketStatus: 'reportTicketStatus',
  supportTicketStatus: 'supportTicketStatus',
  sort: 'sort',
  shopVerificationStatus: 'status',
  categories: 'categories',
}

export const SORT_MODES = {
  LATEST: {
    key: 'latest',
    label: 'Latest',
  },
  OLDEST: {
    key: 'oldest',
    label: 'Oldest',
  },
  ALPHA: {
    key: 'alpha',
    label: 'Alphabetical',
  },
  REVERSE_ALPHA: {
    key: 'reverse_alpha',
    label: 'Reverse Alphabetical',
  },
}
